import { makeAutoObservable } from 'mobx';

export class BecomePartnerMobxDto {
    email = '';

    phone = '';

    name = '';

    constructor(data?: Partial<BecomePartnerMobxDto>) {
        Object.assign(this, data);
        makeAutoObservable(this);
    }
}
